import type React from 'react';
import { useCallback } from 'react';

import confetti from 'canvas-confetti';

const COLORS = ['#8F3DA7', '#FAB5A7', '#718870'];

export function useConfetti() {
    const triggerConfettiFromEvent = useCallback((e: React.MouseEvent<HTMLElement>) => {
        const rect = e.currentTarget.getBoundingClientRect();
        const x = (rect.left + rect.width / 2) / window.innerWidth;
        const y = (rect.top + rect.height / 2) / window.innerHeight;

        confetti({
            particleCount: 120,
            spread: 110,
            angle: 120,
            colors: COLORS,
            drift: -0.1,
            gravity: -0.3,
            startVelocity: 20,
            scalar: 1,
            ticks: 200,
            origin: { x, y },
        });
    }, []);

    return {
        triggerConfettiFromEvent,
    };
}
